<template>
    <div>
    <v-row>
      <v-col class="col-md-7 col-lg-7 col-xl-7">
        <!-- <s-crud
          :single-row="false"
          add
          addNoFunction
          @add="addWorker()"
          searchInput
          @rowSelected="selectedWorker($event)"
          ref="ScrudAssitanceGang"
          title="Contratos"
          :config="config"
          :filter="filter"
          @doubleClick="assignWorker($event)"
        >
          <template v-slot:filter>
            <v-container>
              <v-row justify="center">
                <v-col lg="6"> 
                    <s-select
                        label="Cuadrilla"
                        :items="quadrille"
                        autocomplete
                        item-text="GngName"
                        item-value="GngID"
                        v-model="filter.GngID"
                        clearable
                    ></s-select>
                </v-col>
            </v-row>
            </v-container>
          </template>
        </s-crud> -->

        <s-toolbar
          label="Contratos"
          add
          searchInput
          @textSearch="textSearch($event)" 
          color="#8e8f91"
          dark
          @add="addWorker()"
        ></s-toolbar>
        <v-card>
          <v-container fluid>
            <v-row justify="center">
                <v-col lg="4"> 
                    <s-select
                        label="Cuadrilla"
                        :items="quadrille"
                        autocomplete
                        item-text="GngName"
                        item-value="GngID"
                        v-model="filter.GngID"
                        clearable
                    ></s-select>
                </v-col>
                <v-col lg="4">
                  <s-date label="Fecha" v-model="filter.BeginDate"></s-date>
                </v-col>
                <v-col lg="4">
                  <s-switch label="Mostrar todos los registros" v-model="filter.Everybody" />
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col lg="12">
                  <v-data-table
                    dense
                    @click:row="rowClickSearch"
                    v-model="selectionBefore"
                    :items-per-page="10"
                    :headers="config.headers"
                    item-key="PrsDocumentNumber"
                    :items="items"
                    fixed-header
                    show-select
                    :loading="loadingTable"
                  >
                  <template v-slot:[`item.AgtBeginDate`]="{ item }">
                      {{ $fun.formatDateView(item.AgtBeginDate) }}
                  </template>

                  <template v-slot:[`item.StatusMarking`]="{ item }">
                    <div class="d-flex flex-wrap gap-1">
                      <template v-if="item.Markings && item.Markings.length > 0">
                        <v-chip
                          v-for="(marking, index) in getOrderedMarkings(item.Markings)"
                          :key="index"
                          color="teal darken-3"
                          dark
                          x-small
                          class="mr-1 mb-1"
                        >
                          {{ marking.StatusMarkingName }}
                        </v-chip>
                      </template>
                      <template v-else>
                        <v-chip x-small color="grey" dark>Sin marcación</v-chip>
                      </template>
                    </div>
                  </template>
                  </v-data-table>
                </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col class="col-md-5 col-lg-5 col-xl-5">
        <s-toolbar
          label="Asistencia Masiva"
          remove
          :search="false"
          @removed="removeEvent($event)"
        >
          <template v-slot:options>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" small @click="removeAllWorkers()" elevation="0">
                  <v-icon style="font-size:18px;">mdi-delete-sweep</v-icon>
                </v-btn>
              </template>
              <span>Eliminar todos</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" small @click="massiveAssistance()" elevation="0">
                  <v-icon style="font-size:18px;">mdi-calendar-clock</v-icon>
                </v-btn>
              </template>
              <span>Asistencia masiva</span>
            </v-tooltip>
          </template>
        </s-toolbar>
        <v-card>
          <v-data-table
            dense
            @click:row="rowClick"
            selectable-key="isSelectable"
            v-model="selected"
            :headers="configPanel.headers"
            item-key="PrsDocumentNumber"
            :items="itemsCard"
          ></v-data-table>
        </v-card>
        <v-progress-circular 
          v-if="loading"
          indeterminate
          :size="50"
          color="primary"
        ></v-progress-circular>
      </v-col>

    </v-row>
    
    <!-- CAMBIAR TURNO MASIVO -->
    <v-dialog v-model="showMassiveAssistance" v-if="showMassiveAssistance" persistent max-width="600">
    <v-card>
      <v-card-title>Asignar asistencia masiva</v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <v-row class="pt-3">
          <!-- Fecha de entrada -->
          <v-col cols="6" class="s-col-form">
            <s-date
              label="Fecha Entrada *"
              type="date"
              v-model="item.EntryDate"
            ></s-date>
          </v-col>

          <!-- Hora de entrada -->
          <v-col cols="6" class="s-col-form">
            <s-text
              label="Hora Entrada *"
              type="time"
              v-model="item.EntryTime"
            ></s-text>
          </v-col>

          <!-- Fecha de salida -->
          <v-col cols="6" class="s-col-form">
            <s-date
              label="Fecha Salida *"
              type="date"
              v-model="item.ExitDate"
            ></s-date>
          </v-col>

          <!-- Hora de salida -->
          <v-col cols="6" class="s-col-form">
            <s-text
              label="Hora Salida *"
              type="time"
              v-model="item.ExitTime"
            ></s-text>
          </v-col>

          <!-- Cuadrilla -->
          <v-col cols="12" class="s-col-form">
            <s-select
              label="Asistencia de Cuadrilla"
              :items="quadrille"
              autocomplete
              item-text="GngName"
              item-value="GngID"
              v-model="item.GngID"
            ></s-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">Cancelar</v-btn>
        <v-btn color="accent" @click="save()">
          <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          <span v-else>
            Guardar
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    </div>
  </template>
  
  <script>
  import _sChangeShiftMassService from "@/services/HumanResource/ChangeShiftMass";
  import _sMassiveAssistanceGangService from "@/services/HumanResource/Compensation/HmnMassiveAssistanceGangService";
  import _sHelper from "@/services/HelperService";
  import _sGenParam from "@/services/General/ParameterService";
  import _sQuadriService from "@/services/HumanResource/hmnGang.js";
  
  export default {
    components: { },
    data() {
      
      return {
        selected: [],
        itemsCard: [],
        items:[],
        selectionBefore: [],
        filter: {
            GngID: 1 
        },
        searchText: "",
        isLoading: false,
        showDiaglog: false,
        quadrille: [],
        showMassiveAssistance: false,
        item : {
          GngID : 1
        },
        config: {
          headers: [
            { text: "Documento", value: "PrsDocumentNumber", sortable: true },
            { text: "Empleado", value: "NtpFullName", sortable: true },
            { text: "Fecha Inicio Contrato", value: "AgtBeginDate", sortable: true },
            { text: "Cuadrilla", value: "GngName", sortable: true },
            { text: "Area", value: "AreName", sortable: true },
            { text: "Marcación", value: "StatusMarking", sortable: false },
          ],
        },
        configPanel: {
          headers: [
            { text: "ID", value: "AgtID", sortable: false },
            { text: "Documento", value: "PrsDocumentNumber", sortable: false },
            { text: "Empleado", value: "NtpFullName", sortable: true },
          ],
        },
        loading: false,
        loadingTable: false,
      };
    },
    watch: {
      "filter.GngID"() {
        this.load();
      },
      "filter.BeginDate"() {
        this.load();
      },
      "filter.Everybody"() {
        this.load();
      },
    },
    methods: {
        initialize() {
            this.getQuadrille();
            this.load();
        },
        load() {
        this.loadingTable = true;
          _sMassiveAssistanceGangService
          .list(this.filter, this.$fun.getUserID())
          .then(resp => {
            if(resp.status == 200){
              console.log("resp:",resp);
              this.items = resp.data;
              this.loadingTable = false;
            }
          });
        },
         textSearch(text){
            this.filter.Search = text;
             this.load();
        },
        getQuadrille() {
            let obj = {
                SecStatus: 1,
            };
            _sQuadriService.list(obj, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                this.quadrille = resp.data;
                }
            });
        },
        selectedWorker(items) {
            this.selectionBefore = items;
        },
        addWorker() {
          console.log(this.selectionBefore);
          this.selectionBefore.forEach((element) => {
            console.log(element);
            if (this.itemsCard.find((x) => x.PrsDocumentNumber === element.PrsDocumentNumber) == null) {
              this.itemsCard.push(element);
              
              const index = this.items.findIndex(
                (item) => item.PrsDocumentNumber === element.PrsDocumentNumber
              );
              if (index !== -1) {
                this.items.splice(index, 1);
              }
            }
          });
          
          this.selectionBefore = [];
        },
        removeEvent(value) {
          if (this.selected.length == 1) {
            // Guardar una referencia al elemento que se va a eliminar
            const itemToRemove = this.selected[0];
            
            // Eliminar el elemento de itemsCard
            this.itemsCard = this.itemsCard.filter((x) => x != itemToRemove);
            
            // Añadir el elemento a la lista principal (items)
            this.items.push(itemToRemove);
            
            // Reordenar la lista principal por NtpFullName
            this.items.sort((a, b) => {
              if (a.NtpFullName < b.NtpFullName) return -1;
              if (a.NtpFullName > b.NtpFullName) return 1;
              return 0;
            });
            
            this.selected = [];
          }
        },
        removeAllWorkers() {
          // Devolver todos los trabajadores a la lista principal
          this.itemsCard.forEach(worker => {
            this.items.push(worker);
          });
          
          // Reordenar la lista principal por NtpFullName
          this.items.sort((a, b) => {
            if (a.NtpFullName < b.NtpFullName) return -1;
            if (a.NtpFullName > b.NtpFullName) return 1;
            return 0;
          });
          
          this.itemsCard = [];
          this.selected = [];
        },
        clear() {
            this.itemsCard = [];
        },
        rowClick: function(item, row) {
    
            if (true) {
            this.selected = [item];
            this.row = Object.assign({}, item);
            console.log("Row", item);
            } else {
            if (
                this.selected.find((x) => {
                return x == item;
                }) != null
            )
                this.selected = this.selected.filter((x) => {
                return x != item;
                });
            else {
                this.selected.push(item);
                this.row = Object.assign({}, item);
            }
            }
        },
        rowClickSearch: function(item, row) {
            if (item !== undefined) {
                if(item == this.selectionBefore[0]){
                    this.selectionBefore = [];
                }else{
                    this.selectionBefore = [item];
                    console.log("item Desde la tabla:",item);
                }
            }
        },
        assignWorker(worker) {
            if (this.itemsCard.find((x) => x == worker) == null) this.itemsCard.push(worker);
        },
        massiveAssistance() {
            if (this.itemsCard.length === 0) {
            this.$fun.alert("Por favor seleccione al menos un empleado", "warning");
            } else {
            this.showMassiveAssistance = true;
            }
        },
        cancel() {
            this.showMassiveAssistance = false;
        },
        async save() {

          if(this.item.EntryTime == '' || this.item.ExitTime == '') {
            this.$fun.alert("Por favor seleccione la hora de entrada y salida", "warning");
            return;
          }

          this.isLoading = true;

          try {
            const userID = this.$fun.getUserID();

            //entradas
            const entry = this.itemsCard.map(worker => ({
              ...worker,
              MrkTypeStatusMarking: 1,
              MrkIncidence: 0,
              MrkMarking: this.$fun.combineDateTime(this.item.EntryDate, this.item.EntryTime),
              UsrCreateID: userID,
              UsrID: userID,
              GngID: this.item.GngID,
            }));

            // Enviar entradas
            const EntryResponse = await _sMassiveAssistanceGangService.save(entry, userID);

            if (EntryResponse.status !== 200) throw new Error("Error al registrar entradas");

            //salidas
            const exit = this.itemsCard.map(worker => ({
              ...worker,
              MrkTypeStatusMarking: 2,
              MrkIncidence: 1,
              MrkMarking: this.$fun.combineDateTime(this.item.ExitDate, this.item.ExitTime),
              UsrCreateID: userID,
              UsrID: userID,
              GngID: this.item.GngID,
            }));

            // Enviar salidas
            const ExitResponse = await _sMassiveAssistanceGangService.save(exit, userID);

            if (ExitResponse.status !== 200) throw new Error("Error al registrar salidas");

            this.removeAllWorkers();
            this.itemsCard = [];
            this.showMassiveAssistance = false;
            this.load();
            this.$fun.alert("Asistencia asignada correctamente", "success");
          } catch (error) {
            console.error("Error en asistencia masiva:", error);
            //this.$fun.alert("Hubo un error al asignar la asistencia", "error");
          } finally {
            this.isLoading = false;
          }
        },

        
        getOrderedMarkings(markings) {
          return [...markings].sort((a, b) => new Date(a.MrkMarking) - new Date(b.MrkMarking));
        },
    },
    created(){
        this.initialize();
    }
  };
  </script>
  